// @flow
// This file is for subscription related API calls - all version
import apiService from 'src/services/api-service';
import { getShop } from 'src/helpers';

/**
 * call to tracking event for all version subscription
 * In this case: Tracking event for case price change to GMV campaign
 * @params campaignId
 * @params i18n
 * @return {object}
 */
export const eventTracking = async body => {
  const { response, status } = await apiService.fetchApi('admin-v3.subscription.event-tracking', {
    body
  });
  if (status !== 200 && status !== 201) {
    return {
      response,
      type: 'error'
    };
  }
  return {
    response,
    type: 'success'
  };
};
/**
 * Tracking clicking events for notify price changes campaign banner in homepage
 * @param {string} name
 * @param {string} payload
 * @param {*} i18n
 * @returns
 */
export const trackingEventsBannerForPriceChangeCampaign = async (name, data) => {
  let lastLogin = null;
  try {
    const shop = getShop();
    lastLogin = localStorage.getItem(`${shop}-last-login`);
  } catch (error) {}

  const body = {
    eventName: name,
    payload: {
      ...data
    },
    description: 'Events banner notify price changes clicked',
    timestamp: new Date().toISOString(),
    lastLogin
  };
  return eventTracking(body);
};
